import React from 'react';
import ApartmentCatalog from '../components/ApartmentCatalog';

const ApartmentCatalogPage = () => {
  return (
    <div className="pt-24">
      <ApartmentCatalog />
    </div>
  );
};

export default ApartmentCatalogPage;